import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["textContent"]

import {
  TirPmButton,
  TirPmModal,
  TirPmButtonVariantEnum,
  TirPmButtonSizeEnum,
} from "tir-components";
import { computed, ref } from "vue";
import { TreeItemType } from "../enums";

/**Тип удаляемого элемента */

export default /*#__PURE__*/_defineComponent({
  __name: 'remove-stopper-modal',
  setup(__props, { expose: __expose }) {

const type = ref();

/**Описание ошибки */
const errorMessage = computed(() => {
  switch (type.value) {
    case TreeItemType.Queue:
      return "Очередь содержит задачи.";
    case TreeItemType.Group:
      return "Для удаления папки необходимо очистить её содержимое.";
    case TreeItemType.Namespace:
      return "Имеются очереди. Удалить возможно только пустую от очередей рабочую область.";
  }
});

/**Открытие модального окна по типу удаляемого элемента */
const open = (_type: TreeItemType) => {
  type.value = _type;
};
/**Закрыть окно */
const close = () => {
  type.value = undefined;
};

/**Код для использования по ref */
__expose({ open });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TirPmModal), {
    "is-close-overlay": "",
    classes: "remove-stopper-modal",
    "is-with-back": false,
    "is-visible": !!type.value,
    title: "Удаление невозможно",
    onClose: close
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", {
        textContent: _toDisplayString(errorMessage.value),
        class: "remove-stopper-modal_content"
      }, null, 8, _hoisted_1)
    ]),
    footer: _withCtx(() => [
      _createVNode(_unref(TirPmButton), {
        variant: _unref(TirPmButtonVariantEnum).PrimaryState,
        size: _unref(TirPmButtonSizeEnum).Regular,
        onClick: close
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Понятно ")
        ]),
        _: 1
      }, 8, ["variant", "size"])
    ]),
    _: 1
  }, 8, ["is-visible"]))
}
}

})